import { render, staticRenderFns } from "./ViewsTemplates.vue?vue&type=template&id=15e162f0&scoped=true"
import script from "./ViewsTemplates.vue?vue&type=script&lang=js"
export * from "./ViewsTemplates.vue?vue&type=script&lang=js"
import style0 from "./ViewsTemplates.vue?vue&type=style&index=0&id=15e162f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e162f0",
  null
  
)

export default component.exports